// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type AssetV2Fragment = { __typename?: 'AssetV2', id: string, displayName: string, qsbsEligibility: Types.AssetV2QsbsEligibility, assetStaticID?: string | null, assetStatic?: { __typename?: 'AssetStatic', id: string, taxSitusKind?: Types.AssetTaxSitusKind | null, taxSitusStateCode?: Types.StateCode | null, taxSitusGrantor?: { __typename?: 'ClientProfile', id: string } | null } | null, class: { __typename?: 'AssetClass', id: string, displayName: string }, assetValue?: { __typename?: 'AssetValueV2', id: string, value: CurrencyUSD, ownershipType: Types.AssetValueV2OwnershipType, ownedValue?: CurrencyUSD | null, totalValue?: CurrencyUSD | null, ownedPercent?: Percent | null, shareCount?: GraphQLDecimal | null, shareValue?: CurrencyUSD | null } | null };

export const Operations = {
  Fragment: {
    AssetV2: 'AssetV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AssetV2FragmentDoc = gql`
    fragment AssetV2 on AssetV2 {
  id
  displayName
  qsbsEligibility
  assetStaticID
  assetStatic {
    id
    taxSitusKind
    taxSitusStateCode
    taxSitusGrantor {
      id
    }
  }
  class {
    id
    displayName
  }
  assetValue {
    id
    value
    ownershipType
    ownedValue
    totalValue
    ownedPercent
    shareCount
    shareValue
  }
}
    `;